import { render } from "./DetailProfile.vue?vue&type=template&id=c7916732&scoped=true"
import script from "./DetailProfile.vue?vue&type=script&lang=js"
export * from "./DetailProfile.vue?vue&type=script&lang=js"

import "./DetailProfile.vue?vue&type=style&index=0&id=c7916732&scoped=true&lang=css"
import "./DetailProfile.vue?vue&type=style&index=1&id=c7916732&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7916732"]])

export default __exports__